import { mutation_addAnagraficaToFascicolo, mutation_deleteAnagraficaFromFascicolo, mutation_updateAnagraficaInFascicolo } from "../mutations/anagraficaFascicoloMutations"
import {useMutation, useQuery} from "@1f/react-sdk";
import sharedDatasInstance from "../sharedDatas";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";
import { query_anagrafiche_rel_fascicolo, query_anagraficheIds_byFascicolo_Id } from "../query/anagraficaQueries";
import AnagraficaHelpers from "../helpers/anagraficaHelpers";

export const AnagraficaFascicoloApi = () => {
    const errorApiHelpers = apiErrorHelper();
    let aziendaId = sharedDatasInstance.getPropertyByName("aziendaId");
    let anagHelpers = AnagraficaHelpers();
    const apiPostAnagraficaFascicolo = useMutation(
        mutation_addAnagraficaToFascicolo,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiUpdateAnagraficaFascicolo = useMutation(
        mutation_updateAnagraficaInFascicolo,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiDeleteAnagraficaFascicolo = useMutation(
        mutation_deleteAnagraficaFromFascicolo,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiGetAnagraficaFascicolo = useQuery(
        query_anagrafiche_rel_fascicolo,
        {},
        {lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    const apiGetAnagraficheIdByFascicoloId = useQuery(
        query_anagraficheIds_byFascicolo_Id,
        {},
        {lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )

    const GetAnagraficheIdByFascicoloId = async (fascicoloId) => {
        try {
            let response = await apiGetAnagraficheIdByFascicoloId.fetch({
                fascicoloId: fascicoloId
            })
            if (!response.data.error) {
                return response.data.data.anagrafica;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile recuperare le anagrafiche per il fascicolo");
        }
    }
    const GetAnagraficaFascicoloByAnagraficaId = async (anagraficaId) => {
        if(anagraficaId !== undefined && anagraficaId > 0) {
            try {
                let anagraficaFascicoloResponse = await apiGetAnagraficaFascicolo.fetch({
                    anagraficaId: anagraficaId
                })
                if(!anagraficaFascicoloResponse.data.error) {
                    return anagraficaFascicoloResponse.data.data.anagrafica_fascicolo;
                }
            } catch (error) {
                let errorMessage = errorApiHelpers.handleApiError(error);
                throw new Error(errorMessage || "Impossibile recuperare l'anagrafica del fascicolo");
            }
        } else {
            return null
        }
    }
    const PostAnagraficaFascicolo = async (anagraficaFascicolo,fascicoloId) => {
        try {
            let anagFascToPost = {
                anagraficaId: anagraficaFascicolo.anagraficaId,               
                tipoAnagId : anagraficaFascicolo.tipoAnagId,
                tipoPartId : anagraficaFascicolo.tipoPartId,
                tipoPartDesc : anagraficaFascicolo.tipoPartDesc,
                dataFine : anagraficaFascicolo.dataFine ?? null,
                tipoRapp : anagHelpers.FromRappIdToRappDesc(anagraficaFascicolo.tipoRappId),
                tipoRappDesc : anagraficaFascicolo.tipoRappDesc,
            }
            let postAngFascResponse = await apiPostAnagraficaFascicolo.fetch({
                fascicoloId : fascicoloId,
                aziendaId :aziendaId,
                dataInput : anagFascToPost 
            })
            if(postAngFascResponse && postAngFascResponse.data){
                return postAngFascResponse.data.data.addAnagraficaToFascicolo;
            }
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile creare l'anagrafica del fascicolo");
        }
    }
    const UpdateAnagraficaFascicolo = async (anagraficaFascicolo,fascicoloId) => {
        try {
            let anagFascToUpdate = {
                tipoPartId : anagraficaFascicolo.tipoPartId,
                tipoPartDesc : anagraficaFascicolo.tipoPartDesc,
                dataFine : anagraficaFascicolo.dataFine ?? null,
                tipoRapp : anagHelpers.FromRappIdToRappDesc(anagraficaFascicolo.tipoRappId),
                tipoRappDesc : anagraficaFascicolo.tipoRappDesc,
                tipoAnagId : anagraficaFascicolo.tipoAnagId
            }
            let anagFascicoloUpdateResponse = await apiUpdateAnagraficaFascicolo.fetch({
                fascicoloId : fascicoloId,
                anagraficaFascicoloId : anagraficaFascicolo.id,
                aziendaId :aziendaId,
                dataInput : anagFascToUpdate
            }) 
            if(anagFascicoloUpdateResponse.data) {
                return anagFascicoloUpdateResponse.data.data.updateAnagraficaInFascicolo;
            }
        } catch (error) {
            let statusCode = errorApiHelpers.retriveErrorStatusCode(error);
            if(statusCode === 409) {
                throw new Error("L'anagrfica è già presente in questo fascicolo con questo ruolo");
            }
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile aggiornare l'anagrafica del fascicolo");
        }
    }
    const DeleteAnagraficaFascicolo = async (fascicoloId,anagraficaFascicoloId) => {
        try {
            let deleteAnagFascResponse = await apiDeleteAnagraficaFascicolo.fetch({
                fascicoloId : fascicoloId,
                anagraficaFascicoloId : anagraficaFascicoloId,                
                aziendaId :aziendaId
            })
            if(deleteAnagFascResponse.data) {
                return deleteAnagFascResponse.data.data.deleteAnagraficaFromFascicolo;
            }                   
        } catch (error) {
            let errorMessage = errorApiHelpers.handleApiError(error);
            throw new Error(errorMessage || "Impossibile eliminare l'anagrafica dal fascicolo");
        }
    }

    return {
        GetAnagraficheIdByFascicoloId,
        GetAnagraficaFascicoloByAnagraficaId,
        PostAnagraficaFascicolo,
        UpdateAnagraficaFascicolo,
        DeleteAnagraficaFascicolo
    }
}